// Request-header helpers for optimistic concurrency and idempotent creates (constitution §4.7,
// §4.12). The formats match the API middleware so a bad value fails here, before the network.

const MAX_VERSION = 4_294_967_295; // versions are INT UNSIGNED
// Same rule as the API's idempotency middleware: 8–128 of A–Z a–z 0–9 - _.
// Matches "3f2b9c1e-0d4a-4c1e-9b7a-2f1e0d9c8b7a"; rejects "short", "has spaces in it", "a/b+c=d!".
// https://regex101.com/?regex=%5E%5BA-Za-z0-9_-%5D%7B8%2C128%7D%24&testString=3f2b9c1e-0d4a-4c1e-9b7a-2f1e0d9c8b7a%0Ashort&flavor=javascript
const IDEMPOTENCY_KEY = /^[A-Za-z0-9_-]{8,128}$/;

/** `If-Match` value for a record version: a strong validator such as `"3"`. */
export function ifMatch(version: number): string {
  if (!Number.isInteger(version) || version < 0 || version > MAX_VERSION) {
    throw new RangeError(`If-Match needs a record version, got ${String(version)}`);
  }
  return `"${String(version)}"`;
}

/** A fresh key per user action. Reuse the same key when retrying that action. */
export function newIdempotencyKey(): string {
  return globalThis.crypto.randomUUID();
}

export function isIdempotencyKey(value: string): boolean {
  return IDEMPOTENCY_KEY.test(value);
}

/** Checks a caller-supplied key against the API's format (8–128 of A–Z a–z 0–9 - _). */
export function idempotencyKey(value: string): string {
  if (!isIdempotencyKey(value)) {
    throw new RangeError('Idempotency-Key must be 8 to 128 letters, digits, "-" or "_"');
  }
  return value;
}
